import React, { useReducer } from 'react'
import styles from './index.scss'
import classnames from 'classnames'
import DpBusinessPopup from '@/libs/components/DpBusinessComponents/DpBusinessPopup'
import { RightOutline } from 'antd-mobile-icons'
import DpTracker from '@/libs/components/DpTrackerComponents/DpTracker'
import { TrackView } from '@dragonpass/intl-unified-tracker'

type record = {
  label: string,
  value: string,
  key?: string | number
}

export type IDpBusinessCommodityService = {
  styles?: React.CSSProperties
  data: record[]
  customStyles?: React.CSSProperties
  hasTrackerPermission?: boolean
}

const Service = (props: IDpBusinessCommodityService) => {
  const [visible, toggle] = useReducer((prevState) => !prevState, false);

  const clickToggle = () => {
    if (props?.hasTrackerPermission) {
      window?.dpTracker?.sendClk?.({
        eventData: {
          module_name: '查看服务说明',
        },
      })
    }
    toggle()
  }
  return (
    <>
      <div className={classnames([styles['dp-business-commodity--serviceContainer']])} style={props?.styles}>
        <div className={classnames([styles['dp-business-commodity--service']])} style={props?.styles}>
          <div className={styles['dp-business-commodity--service-left']}>服务说明</div>
          <div aria-label={lang['服务说明']} className={styles['dp-business-commodity--service-center']} onClick={() => clickToggle()}>
            {props?.data?.map?.((item: record) => item?.key)?.join?.(' · ')}
          </div>
          <div aria-label={lang['服务说明']} className={styles['dp-business-commodity--service-right']} onClick={() => clickToggle()}>
            <RightOutline />
          </div>
        </div>
      </div>
      <DpBusinessPopup
        visible={visible}
        onClose={() => toggle()}
        title={'服务说明'}
        headerStyle={{ borderBottomWidth: 0, color: 'var(--third-text-color)' }}
        titleStyle={{
          color: 'var(--primary-text-color, #202020)',
          textAlign: 'center',
        }}
        popupBodyStyles={{
          ...props?.customStyles,
          background: `var(--page-bg-color)`,
        }}
        containerStyles={{
          background: `var(--content-bg-color, #ffffff)`,
          borderRadius: '16px',
          margin: '0 10px 10px',
        }}
      >
        <DpTracker>
          <TrackView
            component="div"
            trackClk={false}
            trackData={{
              module_name: `查看服务说明弹窗`,
            }}
            trackExp={props?.hasTrackerPermission}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
          {
            props?.data?.map((item: record) => {
              return (
                <div key={item.key}>
                  <div className={styles['dp-business-commodity--service-title']}>{item.key}</div>
                  <div className={styles['dp-business-commodity--service-concent']}>{item.value}</div>
                </div>
              )
            })
          }
          </TrackView>
        </DpTracker>
      </DpBusinessPopup>
    </>
  )
}

export default Service
